import { BaseInterceptor } from '../base'

/**
 * Intercepts and revokes object URLs created with the URL Web API after a response is returned from that URL
 * See: https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
 */
export class RevokeObjectURLResponseInterceptor extends BaseInterceptor {
  constructor () {
    super({
      method: 'get',
      path: 'blob\\:(.*)/:objectId'
    })
  }

  /**
   * On Intercept, revoke the Object URL to free resources
   *
   * @param {object} ctxt Response context
   * @param {object} ctxt.config Request config
   * @param {object} params Contextual params
   * @returns {object} Response context
   */
  async onIntercept (ctxt, params = {}) {
    URL.revokeObjectURL(ctxt.config.url)
    return ctxt
  }
}
